/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class AddItemAssistant extends Assistant {
        form_menu = document.createElement("div");
        customer_menu = document.createElement("div");
        stock_suggestion_container = document.createElement("div");
        error_container: HTMLElement;
        ean_input: HTMLInputElement;
        sku_input: HTMLInputElement;
        description_input: HTMLInputElement;
        submit_button: HTMLElement;
        customerId: string;
        resultCount = 0;
        callback: (itemId: string) => void;
        constructor() {
            super();

            //setup stock screen
            var stock_headline = this.customer_menu.appendChild(document.createElement("h1"));
            stock_headline.innerHTML = SP.Localize("sentance_select_customer");
            this.customer_menu.append(this.stock_suggestion_container);


            this.form_menu.innerHTML = `
                <h1>${SP.Localize("sentance_scan_barcode")}</h1>
                <center><img src="/terminal/img/scan.png"></center>
                <h1>${SP.Localize("sentance_enter_sku")}</h1>
                <input type="text" placeholder="${SP.Localize("word_sku")}" autocomplete="off" tabindex="1" style="margin-bottom:5px;" class="sku_input search_input form-control">
                <h1>${SP.Localize("sentance_enter_barcode")}</h1>
                <input type="text" placeholder="${SP.Localize("word_barcode")}" autocomplete="off" tabindex="2" style="margin-bottom:5px;" class="barcode_input search_input form-control">
                <h1>${SP.Localize("sentance_enter_description")}</h1>
                <input type="text" placeholder="${SP.Localize("word_description")}" autocomplete="off" tabindex="3" style="margin-bottom:5px;" class="description_input search_input form-control">
                <div class="error">Item Not Found</div>
                <div class="btn noselect grad-green"><span class="action">${SP.Localize("word_add")}</span></div>
            `;

            this.ean_input = this.form_menu.querySelector(".barcode_input");
            this.sku_input = this.form_menu.querySelector(".sku_input");
            this.description_input = this.form_menu.querySelector(".description_input");
            this.error_container = this.form_menu.querySelector(".error");
            this.submit_button = this.form_menu.querySelector(".btn");
            this.submit_button.addEventListener("click", async () => {
                var result = await SP.post<any>("/api/v1/item/create", {
                    sku: this.sku_input.value,
                    barcodes: [this.ean_input.value],
                    description: this.description_input.value,
                    customerId: this.customerId
                });

                if (result.status != 200) {
                    this.error_container.innerHTML = result.msg;
                    this.error_container.style.display = "block";
                    SP.Sounds.Error.play();
                }
                else {
                    this.callback(result.itemId);
                    this.close();
                }
            });

            this.sku_input.addEventListener("keydown", (e) => {
                if (e.which == 13) this.ean_input.focus();
            });

            this.ean_input.addEventListener("keydown", (e) => {
                if (e.which == 13) this.description_input.focus();
            });

            //this.description_input.addEventListener("keydown", (e) => {
            //    if (e.which == 13) this.submit_button.click();
            //});
          

            this.container.appendChild(this.form_menu);
            this.container.appendChild(this.customer_menu);
        }


        hide() {
            this.customer_menu.style.display = "none";
            this.form_menu.style.display = "none";
        }

        async open_customer_picker() {
            this.hide();
            this.container.style.display = "block";
            this.customer_menu.style.display = "block";
            let customers = await SP.Data.Customer.getCustomerInfos(true);
            this.stock_suggestion_container.innerHTML = "";
            if (customers.length == 1) {
                this.customerId = customers[0].customerId;
                return this.open_form();
            }

            customers.forEach(c => {
                this.addCustomer(c);
            });
        }

        open_form() {
            this.hide();
            this.ean_input.value = "";
            this.sku_input.value = "";
            this.description_input.value = "";
            this.error_container.style.display = "none";

            this.container.style.display = "block";
            this.form_menu.style.display = "block";
        }

        clear() {
            //clear home buttons
            this.container.style.display = "none";
        }

        addCustomer(item: SP.CustomerInfo) {
            var c = this.stock_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.innerHTML = `<div class='action'>${item.customerName}</div>`;
            c.addEventListener("click", () => {
                this.customerId = item.customerId;
                this.open_form();
            });
        }

        bound = false;

        async open(callback: (itemId: string) => void) {
            this.callback = callback;
            this.open_customer_picker();

            this.ean_input.value = "";
            //this.ean_input.focus();

            if (!this.bound) {
                barcodeListener.on(null, this.scanBarcode, this);
                this.bound = true;
            }
        }




        close() {
            if (this.bound) {
                barcodeListener.off(null, this.scanBarcode);
                this.bound = false;
            }
            super.close();
        }

        scanBarcode(bc: string) {
            SP.blurActive();
            this.ean_input.value = bc;
            this.sku_input.value = bc;
            this.description_input.focus();
            return false;
        }
    }


}